export default "__VITE_ASSET__CGeOcmZW__"